import { Navigate, Outlet, useSearchParams } from "react-router-dom";
import { useAuthContext } from "../context/authContext";
import Header from "../components/Header";
import Footer from "../components/Footer";

import { FaWhatsapp } from "react-icons/fa";

const VISTA_KEY = "__ver_sitio_como_visitante__";

function PublicRoute() {
  const { user } = useAuthContext();
  const [searchParams] = useSearchParams();

  // El boton "Ver sitio" del dashboard abre el sitio publico en una pestaña
  // nueva que comparte la sesion; sin esto, el redirect de abajo mandaria esa
  // pestaña de vuelta al panel. Se guarda en sessionStorage (propio de esa
  // pestaña) para que no se pierda al navegar a otra pagina publica sin el
  // parametro en la URL.
  if (searchParams.has("vista")) {
    window.sessionStorage.setItem(VISTA_KEY, "1");
  }
  const verComoVisitante = window.sessionStorage.getItem(VISTA_KEY) === "1";

  if (user && !verComoVisitante) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Header />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
      <a
        href="https://api.whatsapp.com/send?phone=5492241460121&text=Hola%20Agustin,%20quisiera%20realizar%20una%20consulta,%20Gracias!"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-5 right-5 bg-primary text-white p-3 rounded-full shadow-lg hover:opacity-80 transition-colors z-50"
        aria-label="Enviar mensaje a través de WhatsApp"
      >
        <FaWhatsapp className="h-10 w-10" />
      </a>
    </div>
  );
}

export default PublicRoute;
